import { render, staticRenderFns } from "./SubscriptionsView.vue?vue&type=template&id=5b8bd542"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports